/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Box,
  Flex,
  Link,
  Switch,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@tonic-one/react';
import isEqual from 'lodash/isEqual';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ButtonTab from 'src/components/Common/ButtonTab';
import { FormLabel, TitleLabel } from 'src/components/Common/FormComponent';
import NotifyAdmin from 'src/components/FilterNotification/NotifyAdmin';
import NotifyUser from 'src/components/FilterNotification/NotifyUser';
import {
  DlpPolicyItem,
  EnableDisableStatus,
} from 'src/pages/Policy/utils/types';
import { useWhyDidYouUpdate } from 'src/utils/hooks';

import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import AdvancedOptionModal from '@Policy/AdvancedThreatProtection/PolicyTemplate/Components/AdvancedOptionModal';
import { kfAdvancedOptionConfigSelector } from '@Policy/store/filters/keywordExtraction';
import Actions from '@Policy/AdvancedThreatProtection/PolicyTemplate/Components/Actions';
import { slfActionDataSelector } from '@Policy/store/filters/shareLink';
import { PolicyModeEnum } from '@Policy/utils/constants';

function SlfNotification() {
  const { t } = useTranslation();

  // get store from context
  const contextStore = usePolicyContext();
  const policySelector = templateSelector(contextStore)<DlpPolicyItem>;
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const ntfAdminIntervalNum = policySelector(
    (s) => s.tmSlfFilters?.notification.ntfAdminIntervalNum
  );
  const ntfAdminIntervalType = policySelector(
    (s) => s.tmSlfFilters?.notification.ntfAdminIntervalType
  );
  const ntfAdminMessage = policySelector(
    (s) => s.tmSlfFilters?.notification.ntfAdminMessage
  );
  const ntfAdminNotifySettingType = policySelector(
    (s) => s.tmSlfFilters?.notification.ntfAdminNotifySettingType
  );
  const ntfAdminSubject = policySelector(
    (s) => s.tmSlfFilters?.notification.ntfAdminSubject
  );
  const ntfEnableNotifyAdmin = policySelector(
    (s) => s.tmSlfFilters?.notification.ntfEnableNotifyAdmin
  );
  const ntfEnableNotifyRecipient = policySelector(
    (s) => s.tmSlfFilters?.notification.ntfEnableNotifyRecipient
  );
  const ntfInternalRecipientMessage = policySelector(
    (s) => s.tmSlfFilters?.notification.ntfInternalRecipientMessage
  );
  const ntfInternalRecipientSubject = policySelector(
    (s) => s.tmSlfFilters?.notification.ntfInternalRecipientSubject
  );
  const ntfToAccount = policySelector(
    (s) => s.tmSlfFilters?.notification.ntfToAccount
  );
  const ntfAdminOccurenceNum = policySelector(
    (s) => s.tmSlfFilters?.notification.ntfAdminOccurenceNum
  );
  const ntfRecipientGroupId = policySelector(
    (s) => s.tmSlfFilters?.notification.ntfRecipientGroupId
  );
  const ntfRecipientGroupEnabled = policySelector(
    (s) => s.tmSlfFilters?.notification.ntfRecipientGroupEnabled
  );
  const recipientGroups = contextSelector((s) => s.recipientGroups);
  const setSlfNtfState = contextSelector((s) => s.setSlfNtfState);

  // local state
  const handleNtfEnableAdminChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSlfNtfState({
        ntfEnableNotifyAdmin: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  const handleNtfAdminToAccountChange = useCallback((toAccount: string) => {
    setSlfNtfState({ ntfToAccount: toAccount });
  }, []);
  const handleNtfAdminNotifySettingTypeChange = useCallback(
    (notifySettingType: number) => {
      setSlfNtfState({
        ntfAdminNotifySettingType: notifySettingType,
      });
    },
    []
  );
  const handleNtfAdminSubjectChange = useCallback((subject: string) => {
    setSlfNtfState({ ntfAdminSubject: subject });
  }, []);
  const handleNtfAdminMessageChange = useCallback((message: string) => {
    setSlfNtfState({ ntfAdminMessage: message });
  }, []);
  const handleNtfAdminIntervalNumChange = useCallback((intervalNum: number) => {
    setSlfNtfState({ ntfAdminIntervalNum: intervalNum });
  }, []);
  const handleNtfAdminIntervalTypeChange = useCallback(
    (intervalType: number) => {
      setSlfNtfState({ ntfAdminIntervalType: intervalType });
    },
    []
  );
  const handleNtfAdminOccurenceNumChange = useCallback(
    (occurenceNum: number) => {
      setSlfNtfState({ ntfAdminOccurenceNum: occurenceNum });
    },
    []
  );
  const handleNtfRecipientGroupIdChange = useCallback(
    (recipientGroupId: number) => {
      setSlfNtfState({ ntfRecipientGroupId: recipientGroupId });
    },
    []
  );
  const handleNtfRecipientGroupEnabledChange = useCallback(
    (enabled: EnableDisableStatus) => {
      setSlfNtfState({ ntfRecipientGroupEnabled: enabled });
    },
    []
  );
  const handleNtfEnableRecipientChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSlfNtfState({
        ntfEnableNotifyRecipient: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  const handleNtfInternalRecipientSubjectChange = useCallback(
    (subject: string) => {
      setSlfNtfState({ ntfInternalRecipientSubject: subject });
    },
    []
  );
  const handleNtfInternalRecipientMessageChange = useCallback(
    (message: string) => {
      setSlfNtfState({ ntfInternalRecipientMessage: message });
    },
    []
  );
  useWhyDidYouUpdate('Antispam ActionNotification', {
    ntfAdminIntervalNum,
    ntfAdminIntervalType,
    ntfAdminMessage,
    ntfAdminNotifySettingType,
    ntfAdminSubject,
    ntfEnableNotifyAdmin,
    ntfEnableNotifyRecipient,
    ntfInternalRecipientMessage,
    ntfInternalRecipientSubject,
    ntfToAccount,
    ntfAdminOccurenceNum,
    ntfRecipientGroupId,
    recipientGroups,
  });
  return (
    <div>
      <Box ml="1px" mt="16px" width="100%">
        <Flex direction="column">
          <Tabs mt="24px">
            <TabList>
              <ButtonTab>{t('policy.notification.admin')}</ButtonTab>
              <ButtonTab>{t('policy.notification.user')}</ButtonTab>
            </TabList>
            <TabPanels py="24px">
              <TabPanel>
                <NotifyAdmin
                  status={ntfEnableNotifyAdmin}
                  toAccount={ntfToAccount}
                  notifySettingType={ntfAdminNotifySettingType}
                  subject={ntfAdminSubject}
                  message={ntfAdminMessage}
                  intervalNum={ntfAdminIntervalNum}
                  intervalType={ntfAdminIntervalType}
                  occurenceNum={ntfAdminOccurenceNum}
                  recipientGroupId={ntfRecipientGroupId}
                  recipientGroups={recipientGroups}
                  recipientGroupEnabled={ntfRecipientGroupEnabled}
                  setStatus={handleNtfEnableAdminChange}
                  setToAccount={handleNtfAdminToAccountChange}
                  setNotifySettingType={handleNtfAdminNotifySettingTypeChange}
                  setSubject={handleNtfAdminSubjectChange}
                  setMessage={handleNtfAdminMessageChange}
                  setIntervalNum={handleNtfAdminIntervalNumChange}
                  setIntervalType={handleNtfAdminIntervalTypeChange}
                  setOccurenceNum={handleNtfAdminOccurenceNumChange}
                  setRecipientGroupId={handleNtfRecipientGroupIdChange}
                  setRecipientGroupEnabled={
                    handleNtfRecipientGroupEnabledChange
                  }
                />
              </TabPanel>
              <TabPanel>
                <NotifyUser
                  status={ntfEnableNotifyRecipient}
                  subject={ntfInternalRecipientSubject}
                  message={ntfInternalRecipientMessage}
                  setStatus={handleNtfEnableRecipientChange}
                  setSubject={handleNtfInternalRecipientSubjectChange}
                  setMessage={handleNtfInternalRecipientMessageChange}
                />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Flex>
      </Box>
    </div>
  );
}
export const SlfBasicAction = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state from store
  const actionData = contextSelector(slfActionDataSelector, isEqual);
  useWhyDidYouUpdate('ShareLinkFilter SlfBasicAction', {
    actionData,
  });
  const policySelector = templateSelector(contextStore);
  const policyMode = policySelector((s) => s.policyMode);
  return (
    <Actions
      actionData={actionData}
      disabledAll={policyMode === PolicyModeEnum.DefaultMonitorPolicy}
    />
  );
};

const ActionNotification = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Box ml="1px" mt="16px" width="100%">
        <Flex direction="column">
          <TitleLabel title={t('policy.label.action')} mb="24px" />
          <SlfBasicAction />
          <TitleLabel title={t('policy.label.notification')} />
          <SlfNotification />
        </Flex>
      </Box>
    </div>
  );
};

export default React.memo(ActionNotification);
